import React, {useState} from 'react';
import Bread from '../../component/Breadcrumbs';
import Sidebar from '../../component/Sidebar';
import ChangePassword from './ChangePassword';
import UpdateProfile from './UpdateProfile';
import Profile from '../Profile';

import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';


import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
// import Alert from '@material-ui/lab/Alert';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
}));

export default function MyProfile(props) {
  const classes = useStyles();
  const [mess, setMess] = useState("");
  const [proMess, setProMess] = useState("");
  const [expanded, setExpanded] = React.useState(false);
  const br = [{
    'title':'Admin Profile',
    'icon':"",
    'url':'/admin/profile'
  }];

  // useEffect(()=>{
  //   // AdminDetail('adminDetail/'+AuthData().id,'GET',AuthData().token).then((result) => {
  //   // });
  // })
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
    const callbackFunction = (childData) => {
      //console.log(childData);
      setMess(childData)
  };
  const callbackFunctionProfile = (childData) => {
    //console.log(childData);
    setProMess(childData)
};
  return (
    <div className={classes.root}>
        
      <Sidebar />
      <main className={classes.content}>
      <div className={classes.toolbar} />
      <Bread data={br} />
       <h1>Profile</h1>
       
       <Grid container spacing={3}>
            <Grid item xs={12} md={8} lg={8}>
              
                <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
                    <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                    >
                    <Typography className={classes.heading}>Change Your Password</Typography>
                    </AccordionSummary>
                    {mess}
                    <AccordionDetails>
                        <ChangePassword parentCallback={callbackFunction} />
                    </AccordionDetails>
                </Accordion>
                <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
                    <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2a-content"
                    id="panel2a-header"
                    >
                    <Typography className={classes.heading}>Update Your Profile</Typography>
                    </AccordionSummary>
                    {proMess}
                    <AccordionDetails>
                    <UpdateProfile parentCallback={callbackFunctionProfile} />
                    </AccordionDetails>
                </Accordion>
             
            </Grid>
            <Grid item xs={12} md={4} lg={4}>
            <Profile />
            </Grid>
        </Grid>
      
      </main>
    </div>
  );
}


// WEBPACK FOOTER //
// ./src/Pages/Auth/MyProfile.js